<template>
  <div
    class="col-sm-12 nopads list-container"
  >
      <Transition name="fade">
        <div v-if="results.length > 0" id="vehicle-list" class="list-content result-table p-2 pointer">
            <vue3-datatable
                :rows="results"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                height="65vh"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
                @row-click="emitData"
            >
                <template #vehicle_type="row">
                    {{ getVehicleTypeName(row.value.vehicle_type) }}
                </template>
            </vue3-datatable>
        </div>
      </Transition>
  </div>
</template>

<script>
import {vehicleHelper} from '../mixins/VehicleMixin'
import {restApi} from "../mixins/RestApiMixin"
import {mapHelper} from "../mixins/MapMixin";
import {timeUtils} from "../mixins/TimeUtils";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'VehicleList',
    components: {Vue3Datatable},
    mixins: [vehicleHelper, restApi, mapHelper, timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fields: [
                {field: 'license_plate', title: this.$t('ins_report.list_label.license_plate'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'make', title: this.$t('vehicle_list.make'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle_model', title: this.$t('vehicle_list.model'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle_type', title: this.$t('vehicle_list.type'),  sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        results: function () {
            this.results.forEach(vehicle => vehicle["_rowVariant"] = vehicle.in_use ? null : 'secondary')
        }
    },
    methods: {
        emitData: function (selected) {
            // Find defect item from original items and emit request to edit
            let p = this.results.find(item => item.id === selected.id)
            if (p) {
                this.$emit('edit', p)
            }
        }

    }
}
</script>
